<template>
  <div class="add-partner mb-3">
    <h3 class="text-primary main-title">Add Partner</h3>
    <div class="w-100 d-flex justify-content-start sticky-header">
      <Stepper
        :options="stepperOptions"
        :activeBlock="block"
        :goTo="slideTo"
      ></Stepper>
    </div>
    <ValidationObserver ref="addPartner" v-slot="{ handleSubmit }">
      <form id="addPartner" @submit.prevent="handleSubmit(onSubmit)">
        <div v-show="block == 0">
          <CCard class="mt-2">
            <CCardBody>
              <h5 class="pb-2 text-primary">Partner Details</h5>
              <CRow>
                <CCol lg="6">
                  <CRow name="customer_type" class="mb-3">
                    <label class="col-lg-12 col-md-12 required"
                      >Select the type of Customer</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <Select
                          name="customer_type_id"
                          :value="partner.customer_type_id"
                          :options="
                            options && options['customer_type']
                              ? options['customer_type']
                              : []
                          "
                          :multiple="false"
                          :clearable="false"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>

                <CCol lg="6" v-if="isHospital || isEducationalInstitute || isAgency">
                  <CRow class="mb-3">
                    <label class="col-lg-12 col-md-12 required"
                      >Organisation Type</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <Select
                          name="organisation_type_id"
                          :value="partner.organisation_type_id"
                          :options="
                            options && options['organization_type']
                              ? options['organization_type']
                              : []
                          "
                          :multiple="false"
                          :clearable="false"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CRow name="institution_name" class="mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Institution Name</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="name"
                          :value="partner.name"
                          @input="handleInput"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>

                <CCol md="6">
                  <CRow class="row mb-3">
                    <label
                      name="lbl_upload-document"
                      class="required col-lg-12 col-md-12"
                      >Partner Logo</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <input
                        name="upload-document"
                        type="file"
                        ref="fileref"
                        :accept="arraytoComma(fileType)"
                        @change="selectedFile"
                      />
                    </div>
                  </CRow>
                </CCol>

                <CCol lg="6">
                  <CRow name="tags" class="mb-3">
                    <label class="required col-lg-12 col-md-12">Tags</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <Select
                          name="tags"
                          :value="partner.tags"
                          :options="
                            options && options['tags'] ? options['tags'] : []
                          "
                          :multiple="true"
                          :clearable="false"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>

                <CCol lg="6">
                  <CRow class="mb-3" name="country">
                    <label class="required col-lg-12 col-md-12">Country</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        ref="country_id"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <Select
                          name="country_id"
                          :value="partner.country_id"
                          :options="
                            options && options['country']
                              ? options['country']
                              : []
                          "
                          :multiple="false"
                          :clearable="true"
                          @input="handleChangeSelect"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>

                <CCol lg="6">
                  <CRow name="address" class="mb-3">
                    <label class="col-lg-12 col-md-12">Address</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider v-slot="{ errors }">
                        <TextArea
                          name="address"
                          :value="partner.address"
                          :error="errors[0]"
                          @input="handleInput"
                          :rows="3"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>

                <CCol lg="12">
                  <CRow name="institution_name" class="mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Description</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <RichTextEditor
                          name="quick_description"
                          :value="partner.quick_description"
                          @input="handleInput"
                          :customToolbar="customToolbar"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <CCard>
            <CCardBody>
              <h5 class="pb-2 text-primary">Main Contact</h5>
              <CRow>
                <CCol lg="6">
                  <CRow name="first_name" class="mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >First Name</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="first_name"
                          :value="partner.first_name"
                          :error="errors[0]"
                          @input="handleInput"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol lg="6">
                  <CRow name="last_name" class="mb-3">
                    <label class="required col-lg-12 col-md-12"
                      >Last Name</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <TextInput
                          name="last_name"
                          :value="partner.last_name"
                          :error="errors[0]"
                          @input="handleInput"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CRow name="phone" class="mb-3">
                    <label class="required col-lg-12 col-md-12">Phone</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        ref="phone"
                        :rules="{
                          required: true,
                          phone_rule: /^\+\d{1,3}\^\d{1,15}$/,
                        }"
                        v-slot="{ errors }"
                      >
                        <PhoneInput
                          name="phone"
                          :value="partner.phone"
                          :options="
                            options && options['dialingCode']
                              ? options['dialingCode']
                              : []
                          "
                          :error="errors[0]"
                          @change="handleInput"
                          ref="phoneNo"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol lg="6">
                  <CRow name="email" class="mb-3">
                    <label class="required col-lg-12 col-md-12">Email</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <TextInput
                          name="email"
                          :value="partner.email"
                          :error="errors[0]"
                          @input="handleInput"
                          autocomplete="new-email"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6">
                  <CRow name="password" class="mb-3">
                    <label class="col-lg-12 col-md-12">Password</label>
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        name="password"
                        :rules="{
                          password_length: 8,
                          password_strength:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                        }"
                        v-slot="{ errors }"
                      >
                        <PasswordInput
                          name="password"
                          :value="partner.password"
                          @input="handleInput"
                          :error="errors[0]"
                          autocomplete="new-password"
                        />
                        <small class="hint">
                          Password format: 8 characters - containing upper &
                          lower case letters, numbers and a special character.
                          No words.
                        </small>
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
                <CCol md="6">
                  <CRow name="confirm_password" class="row mb-3">
                    <label
                      class="col-lg-12 col-md-12"
                      :class="partner.password ? 'required' : ''"
                      >Confirm Password</label
                    >
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <ValidationProvider
                        :rules="
                          partner.password ? 'required|confirmed:password' : ''
                        "
                        v-slot="{ errors }"
                      >
                        <PasswordInput
                          name="confirmPassword"
                          :value="confirmPassword"
                          @input="handleConfirmPassword"
                          :error="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <div class="text-center mx-0 mt-2 pt-4 action-area">
            <CButton
              variant="outline"
              size="lg"
              type="button"
              color="primary"
              shape="square"
              class="px-5 m-1 mt-3"
              @click="resetForm"
              >Clear All</CButton
            >
            <CButton
              type="button"
              size="lg"
              color="primary"
              shape="square"
              class="px-5 m-1 mt-3"
              @click="slideTo(1)"
              >Next</CButton
            >
          </div>
        </div>

        <div v-show="block == 1">
          <CCard>
            <CCardBody>
              <h5 class="pb-2 text-primary">Select Subscription</h5>
              <table
                class="table table-striped table-hover text-center border-bottom mb-0 w-100"
              >
                <thead>
                  <tr>
                    <th>Options</th>
                    <th
                      v-for="subscription in subscriptions"
                      :key="subscription.subscription_id"
                      :class="{
                        selected_opt_head:
                          subscription.subscription_id ==
                          partner.subscription_id,
                      }"
                    >
                      <CInputRadio
                        :id="'subscription-' + subscription.subscription_id"
                        :value="subscription.subscription_id"
                        @update:checked="
                          () =>
                            (partner.subscription_id =
                              subscription.subscription_id)
                        "
                        :checked="
                          subscription.subscription_id ===
                          partner.subscription_id
                        "
                        name="subscription_type"
                        :label="subscription.subscription_name"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="opt in allOptions" :key="opt.option_id">
                    <td>{{ opt.option_name }}</td>
                    <td
                      v-for="sub in subscriptions"
                      :key="sub.subscription_id"
                      style="text-align: center"
                      :class="{
                        selected_option:
                          sub.subscription_id == partner.subscription_id,
                      }"
                    >
                      <span
                        :class="{ 'text-bold': hasOption(sub, opt.option_id) }"
                        >{{ hasOption(sub, opt.option_id) ? "✓" : "" }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center mx-0 mt-2 pt-4 action-area">
                <CButton
                  variant="outline"
                  size="lg"
                  type="button"
                  color="primary"
                  shape="square"
                  class="px-5 m-1 mt-3"
                  @click="block = 0"
                  >Back</CButton
                >
                <CButton
                  type="submit"
                  size="lg"
                  color="primary"
                  shape="square"
                  class="px-5 m-1 mt-3"
                  >Submit</CButton
                >
              </div>
            </CCardBody>
          </CCard>
        </div>
      </form>
    </ValidationObserver>
    <CropperModal
      v-if="cropperModal.isShowPopup"
      :isShowPopup="cropperModal.isShowPopup"
      :fileData="cropperModal.fileData"
      modalColor="primary"
      :buttonLabel="cropperModal.buttonLabel"
      @modalCallBack="cropperModalCallBack"
      :aspectRatio="cropperModal.aspectRatio"
    />
    <CToaster v-if="isFileError" :autohide="3000" position="top-right">
      <CToast :show="true" class="bg-danger text-white"
        >File too Big, please select a file less than 2mb</CToast
      >
    </CToaster>
    <CToaster v-if="isFileTpeValid" :autohide="5000" position="top-right">
      <CToast :show="true" class="bg-danger text-white"
        >Allowed File Type {{ FileTypeError }}</CToast
      >
    </CToaster>
  </div>
</template>
<script>
import Vue from "vue";

import Select from "@/components/reusable/Fields/Select.vue";
import TextInput from "@/components/reusable/Fields/TextInput";
import TextArea from "@/components/reusable/Fields/TextareaInput";
import RichTextEditor from "@/components/reusable/Fields/RichTextEditor";
import CropperModal from "@/components/reusable/CropperModal";
import PhoneInput from "@/components/reusable/Fields/PhoneInput";
import PasswordInput from "@/components/reusable/Fields/PasswordInput";
import { CCardBody, CInputRadio } from "@coreui/vue";

import { extend } from "vee-validate";
import {
  required,
  email,
  confirmed,
  regex,
  min,
  numeric,
} from "vee-validate/dist/rules";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import Stepper from "@/components/reusable/bars/stepper.vue";

extend("required", { ...required, message: "This field is required" });
extend("email", { ...email, message: "Invalid email" });
extend("password_length", {
  ...min,
  message: "Password be atleast 8 characters",
});
extend("password_strength", {
  ...regex,
  message: "Password must have capitals, numbers and special characters",
});
extend("confirmed", {
  ...confirmed,
  message: "This field should match password",
});
extend("numeric", { ...numeric, message: "Only numbers are allowed" });
extend("phone_rule", {
  ...regex,
  message: "Only numbers are allowed(Maximum of 15 digits)",
});

export default {
  components: {
    Select,
    TextInput,
    TextArea,
    RichTextEditor,
    CropperModal,
    PhoneInput,
    PasswordInput,
    Stepper,
    CInputRadio,
  },
  data() {
    return {
      fileType: ["png", "jpeg", "jpg"],
      partner: {
        name: null,
        customer_type_id: null,
        organization_type_id: null,
        quick_description: null,
        tags: [],
        country_id: null,
        is_partner: true,
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
        password: null,
        subscription_id: 1,
      },
      payload: {},
      isFileError: false,
      isFileTpeValid: false,
      FileTypeError: null,
      cropperModal: {
        isShowPopup: false,
        fileData: null,
        buttonLabel: "Apply",
        aspectRatio: 1,
      },
      confirmPassword: null,
      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ header: 1 }, { header: 2 }],
        [{ align: [] }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ script: "sub" }, { script: "super" }],
        [{ direction: "rtl" }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"], // remove formatting button
      ],
      stepperOptions: {
        headers: [
          {
            title: "",
            tooltipTitle: "Partner Details",
            tooltipPlacement: "bottom-start",
          },
          {
            title: "",
            tooltipTitle: "Subscription Details",
            tooltipPlacement: "bottom-start",
          },
        ],
      },
      block: 0,
    };
  },
  computed: {
    ...mapGetters([
      "locationCountryInfo",
      "dialingCodeWithCountryCode",
      "getCustomerTypeList",
      "getOrganisationTypeList",
      "licenseIssuedByCountrys",
      "getLocationByCountrysID",
      "getSubscriptions",
    ]),
    tags() {
      return [
        "Hospital/Clinic",
        "Pharmaceuticals",
        "Education",
        "Governmental",
        "Regulatory Body",
        "Service Provider",
        "Consulting",
        "Supplier",
      ];
    },
    options() {
      return {
        customer_type: this.getCustomerTypeList || [],
        country: this.locationCountryInfo || [],
        dialingCode: this.dialingCodeWithCountryCode || [],
        organization_type: this.getOrganisationTypeList || [],
        tags: this.tags || [],
      };
    },

    isHospital() {
      return this.payload?.customer_type_id === 68 || false; // was 4
    },

    isAgency() {
      return this.payload?.customer_type_id === 71 || false; // was 2
    },

    isEducationalInstitute() {
      return this.payload?.customer_type_id === 72 || false; // was 5
    },

    subscriptions() {
      return this.getSubscriptions || [];
    },

    maxOptions() {
      const lengths = this.getSubscriptions.map((s) => s.options?.length || 0);
      return lengths.length > 0 ? Math.max(...lengths) : 0;
    },

    allOptions() {
      const map = new Map();
      this.subscriptions.forEach((sub) => {
        sub.options.forEach((opt) => {
          map.set(opt.option.option_id, opt.option);
        });
      });

      return Array.from(map.values()).sort((a, b) => a.option_id - b.option_id);
    },
  },
  methods: {
    ...mapActions([
      "initUserFetchOptions",
      "showToast",
      "scrollTop",
      "fetchSubscriptions",
    ]),
    hasOption(subscription, optionId) {
      return subscription.options.some((o) => o.option_id === optionId);
    },
    handleConfirmPassword(name, value) {
      this[name] = value;
    },
    handleInput(name, value) {
      let hasError = {
        phone: "phone",
      };
      if (name !== hasError.phone || (name == hasError.phone && value !== "")) {
        Vue.set(this.partner, name, value);
        Vue.set(this.payload, name, value);
      }
      if (name === hasError.phone && value === "") {
        this.clearFieldErrors(name, hasError);
      }
    },
    handleChangeSelect(name, value) {
      let multiSelectFields = {
        tags: "tags",
      };
      if (multiSelectFields[name] && !this.isParentAdmin) {
        return this.handleChangeMultiSelectAsArray(name, value);
      }
      Vue.set(this.partner, name, value);
      this.payload = {
        ...this.payload,
        [name]: value ? value.id || value.code || value : null,
      };
    },
    getExtension(filename) {
      let parts = filename.split(".");
      return `${parts[parts.length - 1]}`;
    },
    selectedFile(event) {
      this.isFileError = false;
      this.isFileTpeValid = false;
      const size = event.target.files[0]?.size;
      if (Math.round(size / (1024 * 1024)) <= 2) {
        const file = event.target.files[0];
        const fileExt = this.getExtension(file.name);
        const fileTypeString = this.fileType;
        if (fileTypeString.includes(fileExt)) {
          if (file.type.startsWith("image/")) {
            this.cropperModal.fileData = file;
            this.cropperModal.isShowPopup = true;
          } else {
            this.handleFileUploads(file);
          }
        } else {
          this.isFileTpeValid = true;
          this.FileTypeError = this.arraytoComma(fileTypeString);
          this.$refs.fileref.value = "";
          this.showToaster();
        }
      } else {
        this.$refs.fileref.value = "";
        this.isFileError = true;
        this.showToaster();
      }
    },
    showToaster() {
      setTimeout(() => {
        this.isFileError = false;
        this.isFileTpeValid = false;
      }, 5000);
    },
    handleFileUploads(file) {
      this.payoad = {
        ...this.payload,
        file_payload: {
          file,
          fileName: file?.name,
        },
      };
    },
    cropperModalCallBack(action, data) {
      if (action === false) {
        this.cropperModal.isShowPopup = false;
        this.cropperModal.fileData = null;
        this.$refs.fileref.value = "";
      } else {
        let { fileBlob, fileName } = data;
        const payload = {
          fileName,
          blobData: fileBlob,
          document_type_id: 17, // Logo - Document Type Id
        };
        this.payload = {
          ...this.payload,
          file_payload: payload,
        };
        this.cropperModal.isShowPopup = false;
        this.cropperModal.fileData = null;
      }
    },
    resetForm() {
      this.partner = {
        customer_type_id: null,
        organisation_type_id: null,
        name: null,
        address: null,
        country_id: null,
      };
      this.payload = {};
      this.$refs.fileref.value = "";
    },
    async onSubmit() {
      const isValid = await this.$refs.addPartner.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please fill mandatory fields!",
        });
        return;
      }
      this.payload["is_partner"] = true;
      this.payload["original_customer_id"] = _.snakeCase(this.partner["name"]);
      this.payload["subscription_id"] = this.partner["subscription_id"];
      if (![68, 72, 71].includes(this.payload["customer_type_id"])) { // hospital/education/agency, was 4/5/2
        delete this.payload["organisation_type_id"];
      }
      this.$emit("submit", this.payload);
    },
    clearFieldErrors(name, hasError) {
      this.$nextTick(() => {
        if (name === hasError.phone) {
          this.$refs.phone.errors.clear;
          this.$refs.phone.reset();
        } else if (name === hasError.location_id) {
          this.$refs.location_id.errors.clear;
          this.$refs.location_id.reset();
        } else if (name === hasError.country_id) {
          this.$refs.country_id.errors.clear;
          this.$refs.country_id.reset();
        }
      });
    },

    handleChangeMultiSelectAsArray(name, value) {
      Vue.set(this.partner, name, value);
      this.payload = {
        ...this.payload,
        [name]: value
          ? value.map((v) => {
              return v.id || v.code || v;
            })
          : null,
      };
    },
    checkDepententSelect({ changedField, depententField, depentent }) {
      let value =
        this.partner[depententField] && !this.isParentAdmin
          ? this.partner[depententField].filter((val) =>
              this.payload[changedField].includes(val[depentent]),
            )
          : [];
      this.handleChangeSelect(depententField, value);
    },
    arraytoComma(d) {
      return d?.map((v) => "." + v).join(", ");
    },
    async slideTo(event, obj) {
      if (await this.pageValidate()) {
        this.block = event;
      } else {
        this.block = 0;
        this.showPageToaster();
      }
    },
    showPageToaster() {
      this.showToast({
        class: "bg-danger text-white",
        message: "Please fill mandatory fields!",
        autohide: 3000,
      });
    },
    async pageValidate() {
      if (this.block === 0) {
        const isValid = await this.$refs.addPartner.validate();
        return isValid;
      }
      return true;
    },
  },
  mounted() {
    this.initUserFetchOptions();
    this.fetchSubscriptions({
      subscription_type_id: 201,
    });
    this.scrollTop();
  },
};
</script>
<style scoped lang="scss">
.selected_option {
  background-color: #007bff;
  color: white;
}
.selected_opt_head {
  // padding: unset !important;
  // margin: 0.75rem !important;
  background-color: #a9d0fb;
}
</style>
